import { CREATE_AUDIT_TRAIL } from "../actions/types"
import axios from "../auth/axiosAuth"
import { backendURL } from "../config"

export const createAuditTrail = (newAuditTrail) => async (dispatch) => {
    await axios.post(`${backendURL}/audit-trail`, newAuditTrail)
    dispatch({ type: CREATE_AUDIT_TRAIL })
}
